<template>
  <div class="header">
    <div class="header-nav">
      <div class="header-nav-right">
        <div class="header-nav-tool">
          <div v-if="isLogin && isShowEdit" class="header-nav-link" @click="$emit('clickEdit')">{{langEdit}}</div>
          <div v-if="isLogin && isShowInbox" class="header-nav-link" @click="$emit('clickInbox')">{{lang.inbox}}</div>
          <div v-if="isShowShare"
            class="header-nav-link"
            @click="$emit('clickShare')"
            @mouseover="mouseoverShare"
            @mouseout="isShowQrcode=false"
          >{{lang.share}}
            <div class="header-nav-qrcode">
              <transition name="custom-fade">
                <QrcodeTip
                  v-show="!isMobile && isShowQrcode"
                  id="header-nav-qrcode"
                  :style="qrcodeStyle"
                ></QrcodeTip>
              </transition>
            </div>
          </div>
          <div v-if="!isLogin && isShowSignin" class="header-nav-link" @click="$emit('clickSignin')">{{lang.signin}}</div>
          <div v-if="!isLogin && isShowSignup" class="header-nav-link" @click="$emit('clickSignup')">{{lang.signup}}</div>
          <div v-if="isShowSigninMp" class="header-nav-link" @click="$emit('clickSigninMp')">{{lang.signin}}</div>
          <div v-if="isShowSignupMp" class="header-nav-link" @click="$emit('clickSignupMp')">{{lang.signup}}</div>
          <!-- <div v-if="!isLogin && isShowReset" class="header-nav-link" @click="$emit('clickResetPassword')">{{lang.reset_password}}</div> -->
          <div v-if="isLogin && isShowSignout" class="header-nav-link" @click="$emit('clickSignout')">{{lang.signout}}</div>
          <Avatar
            v-if="isLogin && isShowAvatar"
            @click.native="clickAvatar"
            :class="classAvatar"
            :username="username"
            :src="userimg"
            :size="36"
          ></Avatar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from 'vue-avatar'

import env from '@/env.js'
import Mem from '@/Mem.js'

import {
  QrcodeTip
} from '@/components'

export default {
  components: {
    Avatar,
    QrcodeTip
  },
  props: {
    lang: {
      type: Object,
      default () {
        return {
          signup: '注册',
          reset_password: '忘记密码',
          signin: '注册/登录',
          signout: '退出登录',
          share: '分享',
          edit: ['退出编辑', '编辑个人主页', '前往个人主页'],
          inbox: '收件箱'
        }
      }
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    isMyHome: {
      type: Boolean,
      default: false
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShowQrcode: false,
      qrcodeStyle: '',
      activeAvatar: true
    }
  },
  computed: {
    isShowMenu () {
      return this.$route.query.menu !== 'hide'
    },
    menuOnly () {
      return this.$route.query.menuOnly
    },
    menuHide () {
      return this.$route.query.hasOwnProperty('menuOnly') || !this.isShowMenu
    },
    isShowEdit () { return this.isShow('edit') },
    isShowInbox () { return this.isShow('inbox') },
    isShowShare () { return this.isShow('share') },
    isShowSignin () { return this.isShow('signin') },
    isShowSignup () { return this.isShow('signup', false) },
    isShowSigninMp () { return this.isShow('signin-mp', false) },
    isShowSignupMp () { return this.isShow('signup-mp', false) },
    isShowReset () { return this.isShow('reset') },
    isShowSignout () { return this.isShow('signout') },
    isShowAvatar () { return this.isShow('avatar', false) },
    isMobile () { return env.isMobile },
    username () {
      return Mem.get('me.u.account')
    },
    userimg () {
      let img = Mem.get('me.u.card.head_image_url')
      if (img) {
        return img
      }
      return 'https://az.cdn.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_default_image_small.png'
    },
    classAvatar () {
      // if (this.activeAvatar) {
      //   return 'header-nav-avatar header-nav-avatar-shadow'
      // }
      return 'header-nav-avatar'
    },
    langEdit () {
      if (!this.isMyHome) {
        return this.lang.edit[2]
      }
      if (this.isEditMode) {
        return this.lang.edit[0]
      }
      return this.lang.edit[1]
    }
  },
  methods: {
    isShow (menuKey, defaultState = true) {
      return this.menuOnly === menuKey || this.$route.query.hasOwnProperty(menuKey) || (!this.menuHide && defaultState)
    },
    clickAvatar () {
      this.activeAvatar = !this.activeAvatar
      this.$emit('clickAvatar')
    },
    mouseoverShare (evt) {
      // let info = evt.target.getBoundingClientRect()
      this.isShowQrcode = true
      // this.$nextTick(() => {
      //   let el = document.getElementById('header-nav-qrcode')
      //   // this.qrcodeStyle = `left:${info.left - el.offsetWidth / 2 + info.width / 2}px`
      //   this.qrcodeStyle = `left:${el.offsetWidth / 2}px`
      //   console.log('mouseoverShare code', el.offsetWidth)
      //   console.log('mouseoverShare info', info)
      //   console.log('mouseoverShare qrcodeStyle', this.qrcodeStyle)
      // })
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.header {
  & .header-nav {
    position: relative;
    & .header-nav-tool {
      position: absolute;
      display: flex;
      height: 36px;
      @media (--mediaPc) {
        top: 12px;
        right: 20px;
      }
      @media (--mediaMobile) {
        top: calc(12px / var(--scaleMobile));
        right: calc(32px / var(--scaleMobile) - 32px / var(--scaleMobile) / 2);
      }

      & .header-nav-link {
        position: relative;
        color: var(--colorWhite);
        vertical-align: middle;
        cursor: pointer;

        @media (--mediaPc) {
          margin: 0 13px;
        }
        @media (--mediaMobile) {
          margin: 0 calc(32px / var(--scaleMobile) / 2);
        }
        & .header-nav-qrcode {
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0);
        }
        &::before {
          content: '';
          width: 0;
          height: 100%;
          display: inline-block;
          position: relative;
          vertical-align: middle;
        }
      }
      & .header-nav-avatar {
        float: right;
        @media (--mediaPc) {
          margin-left: 30px;
        }
        @media (--mediaMobile) {
          margin-left: calc(32px / var(--scaleMobile) / 2);
        }
      }
      & .header-nav-avatar-shadow {
        box-shadow: 0 0 25px #ffffff, inset 0 0 10px #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/Header.vue